import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import ic_mst_modal from "../../assets/Icon MST.svg";
import ic_address_modal from "../../assets/ic-address-modal.svg";
import ic_email_modal from "../../assets/ic-email-modal.svg";
import zuttoride_logo from "../../assets/ZuttoRide.png";

const MDCompanyInfo = ({ open, onClose }) => {
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < 768 : false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const name = "ZuttoRide Việt Nam";
  const mst = "0105973461";
  const address = "Tòa nhà M.G, 2B Đ. Lam Sơn, Tân Sơn Hòa, Hồ Chí Minh";
  const email = "cskh@zuttoride.vn";
  const logo = zuttoride_logo;

  const info = [
    { label: "Mã số thuế:", value: mst, icon: ic_mst_modal },
    { label: "Địa chỉ:", value: address, icon: ic_address_modal },
    { label: "Email:", value: email, icon: ic_email_modal },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={isMobile ? {
        "& .MuiDialog-container": {
          alignItems: "flex-end !important",
        },
        "& .MuiDialog-paper": {
          margin: "0 !important",
          width: "100% !important",
          maxWidth: "100% !important",
          height: "75% !important",
          maxHeight: "75% !important",
          borderTopLeftRadius: "18px !important",
          borderTopRightRadius: "18px !important",
          borderBottomLeftRadius: "0 !important",
          borderBottomRightRadius: "0 !important",
          bgcolor: "#F0F2F5 !important",
          padding: "15px",
          backgroundImage: "none",
          overflow: "hidden !important",
          position: "absolute !important",
          bottom: "0 !important",
        }
      } : {
        "& .MuiDialog-container": {
          alignItems: "center !important",
        },
        "& .MuiDialog-paper": {
          borderRadius: "16px !important",
          bgcolor: "#F0F2F5 !important",
          padding: "15px",
          backgroundImage: "none",
          width: "600px !important",
          maxWidth: "600px !important",
          height: "auto !important",
          maxHeight: "calc(100% - 64px) !important",
          overflow: "hidden !important",
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "18px",
          fontWeight: 600,
          color: "#343A40",
          pb: 0,
          pt: 1,
          pl: 1,
          position: "relative",
        }}
      >
        Thông tin công ty đối tác
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            right: 10,
            top: "10px",
            bgcolor: "#ffffff",
            borderRadius: "8px",
            width: "24px",
            height: "24px",
            "&:hover": { bgcolor: "#ffffff" },
          }}
        >
          <CloseIcon fontSize="small" sx={{ fontSize: "14px", color: "#646D69" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 1 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <div style={{ padding: "20px 0 0 0", borderTop: "1px solid #646D69", marginTop: 15 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 15, marginBottom: 15 }}>
              {logo && (
                <div style={{ }}>
                  <img src={logo} width={80} alt="provider-logo" style={{ filter: 'drop-shadow(0px 1px 3px rgba(0,0,0,0.09))' }} />
                </div>
              )}
              <b style={{ fontSize: 18 }}>{name}</b>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {info.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      color: "#6C757D",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={item.icon} width={20} alt="company-info-icon" />
                    </div>
                    <div style={{ fontSize: 14 }}>{item.label}</div>
                  </div>
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#343A40",
                      fontSize: 14,
                      textAlign: "right",
                      maxWidth: "65%",
                      wordBreak: "break-word",
                    }}
                  >
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MDCompanyInfo;
